import * as R from "react";
import w, { useMemo as y, useEffect as k } from "react";
import { T as b, a as d, M as u } from "./index-9dd604b0.js";
import { jsx as c } from "react/jsx-runtime";
import { StyleSheetManager as A, ThemeProvider as L } from "styled-components";
import { metaData as x, useUrlChangeListener as E } from "./analytics.js";
import { PageProvider as M } from "./pageContext.js";
import "./index-d0ae5922.js";
import "./creditFigmaToken-9b4c3a39.js";
import "./index-e6249aa0.js";
import "./index-e9bdff4d.js";
import "@ucl/shared-icons";
const P = w.createContext({
  themes: b,
  themeName: d.FORD_CREDIT,
  mode: u.LIGHT_MODE,
  productTeamName: ""
});
function O(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var D = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, I = /* @__PURE__ */ O(
  function(e) {
    return D.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
const v = "ucl-library-global-styles", T = "ucl-library-components-tracking", H = (e) => {
  let r = document.getElementById(v);
  r || (r = document.createElement("style"), r.id = v, document.head.appendChild(r)), r.innerHTML !== e && (r.innerHTML = e);
}, F = (e, r) => {
  var n, i;
  let t = document.getElementById(T);
  if (r && t)
    return (n = t.remove) == null ? void 0 : n.call(t);
  t || (t = document.createElement("script"), t.id = T, t.defer = !0, document.body.appendChild(t)), t.textContent !== e ? t.textContent = e : (i = window == null ? void 0 : window.trackPage) == null || i.call(window);
}, N = ({
  themes: e = b,
  themeName: r = d.FORD_CREDIT,
  mode: t = u.LIGHT_MODE,
  theme: n,
  globalStyles: i,
  isGlobalStyleRequired: h = !0,
  disableGlobalStyles: p = !h,
  children: m,
  productTeamName: f,
  disableAnalytics: C
}) => {
  const a = y(
    () => {
      var l, s;
      return n || ((l = e[r]) == null ? void 0 : l[t]) || ((s = e[d.FORD_CREDIT]) == null ? void 0 : s[u.LIGHT_MODE]);
    },
    [n, t, r, e]
  ), o = y(() => i || a.globalStyles || "", [i, a.globalStyles]);
  k(() => {
    !p && H(typeof o == "string" ? o : o.join(`
`));
  }, [o, p]), k(() => {
    x.setProductTeamName(f), x.setThemeName(r);
  }, [f, r]), E(() => F("window.trackPage();"), r === d.FORD_CREDIT || C);
  const g = {
    themes: e,
    themeName: r,
    mode: t,
    theme: a,
    globalStyles: o,
    isGlobalStyleRequired: h,
    disableGlobalStyles: p
  }, S = () => typeof m == "function" ? m({ ...g }) : m;
  return /* @__PURE__ */ c(
    A,
    {
      enableVendorPrefixes: !0,
      shouldForwardProp: (l, s) => typeof s == "string" ? I(l) : !0,
      children: /* @__PURE__ */ c(M, { children: /* @__PURE__ */ c(P.Provider, { value: g, children: /* @__PURE__ */ c(L, { theme: a, children: S() }) }) })
    }
  );
}, K = () => {
  const { theme: e } = R.useContext(P);
  if (!e)
    throw new Error("useTheme must be used within a ThemeProvider");
  return e;
};
export {
  P as ThemeContext,
  N as ThemeProvider,
  H as injectGlobalStyles,
  F as injectScript,
  K as useTheme
};
